var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_92714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29983 18.2518C6.77311 17.7848 6.77311 17.0277 6.29983 16.5607C5.82656 16.0938 5.05922 16.0938 4.58595 16.5607C4.11267 17.0277 4.11267 17.7848 4.58595 18.2518C5.05922 18.7187 5.82656 18.7187 6.29983 18.2518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44283 18.8286C4.64712 18.8286 3.99951 18.1896 3.99951 17.4045C3.99951 16.6194 4.64712 15.9805 5.44283 15.9805C6.23854 15.9805 6.88614 16.6194 6.88614 17.4045C6.88614 18.1896 6.23854 18.8286 5.44283 18.8286ZM5.44283 16.4371C4.90203 16.4371 4.46234 16.8709 4.46234 17.4045C4.46234 17.9381 4.90203 18.3719 5.44283 18.3719C5.98362 18.3719 6.42331 17.9381 6.42331 17.4045C6.42331 16.8709 5.98362 16.4371 5.44283 16.4371Z",
    fill: "#0066CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3377 2.60547H8.4409C6.83132 2.60547 5.52686 3.89288 5.52686 5.48063V19.2737C5.52686 20.8618 6.83168 22.1488 8.4409 22.1488H16.8537C18.4633 22.1488 19.7677 20.8614 19.7677 19.2737V7.96306L14.3377 2.60547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3377 2.60547H8.4409C6.83132 2.60547 5.52686 3.89288 5.52686 5.48063V19.2737C5.52686 20.8618 6.83168 22.1488 8.4409 22.1488H16.8537C18.4633 22.1488 19.7677 20.8614 19.7677 19.2737V7.96306L14.3377 2.60547Z",
    fill: "url(#paint0_linear_371_92714)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8537 22.375H8.44087C6.70633 22.375 5.29541 20.9829 5.29541 19.2715V5.47848C5.29541 3.76709 6.70633 2.375 8.44087 2.375H14.3377C14.3989 2.375 14.458 2.39889 14.5014 2.44174L19.9311 7.79934C19.9746 7.84219 19.9988 7.90015 19.9988 7.96092V19.2719C19.9988 20.9833 18.5879 22.3754 16.8533 22.3754L16.8537 22.375ZM8.44087 2.83165C6.96159 2.83165 5.75824 4.01895 5.75824 5.47848V19.2715C5.75824 20.731 6.96159 21.9183 8.44087 21.9183H16.8537C18.3329 21.9183 19.5363 20.731 19.5363 19.2715V8.05541L14.2419 2.83165H8.44087Z",
    fill: "#0066CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7681 8.18933C19.7681 8.18933 19.7678 8.18933 19.7674 8.18933H15.4955C14.7294 8.18933 14.106 7.57425 14.106 6.81831V2.60341C14.106 2.51102 14.1622 2.42777 14.2487 2.39229C14.3352 2.35716 14.4346 2.37648 14.5008 2.44182L19.9202 7.78888C19.9686 7.83068 19.9992 7.89215 19.9992 7.96065C19.9992 8.08675 19.8956 8.18897 19.7678 8.18897L19.7681 8.18933ZM14.5688 3.15455V6.81831C14.5688 7.32239 14.9843 7.73267 15.4955 7.73267H19.2088L14.5688 3.15455Z",
    fill: "#0066CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5534 10.5117C4.83352 10.5117 4.25 11.0875 4.25 11.7977V17.1831H4.27385C4.38992 16.5901 4.91825 16.1419 5.5534 16.1419H18.6792V10.5117H5.5534Z",
    fill: "#0066CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.27382 17.4093H4.24997C4.12216 17.4093 4.01855 17.307 4.01855 17.1809V11.7956C4.01855 10.9606 4.7071 10.2812 5.55337 10.2812H18.6792C18.807 10.2812 18.9106 10.3835 18.9106 10.5096V16.1398C18.9106 16.2659 18.807 16.3681 18.6792 16.3681H5.55337C5.04069 16.3681 4.59816 16.7281 4.50096 17.2241C4.47996 17.3316 4.38455 17.4093 4.27382 17.4093ZM5.55337 10.7379C4.96237 10.7379 4.48138 11.2125 4.48138 11.7956V16.3424C4.76051 16.0741 5.14109 15.9114 5.55337 15.9114H18.4478V10.7379H5.55337Z",
    fill: "#0066CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74072 11.9463C7.74072 11.8511 7.8194 11.7734 7.91161 11.7734H8.8889C9.58136 11.7734 10.0371 12.1367 10.0371 12.7335V12.7422C10.0371 13.3953 9.48488 13.7325 8.83193 13.7325H8.08678V14.6493C8.08678 14.7445 8.0081 14.8221 7.91161 14.8221C7.81513 14.8221 7.74072 14.7441 7.74072 14.6493V11.947V11.9463ZM8.8451 13.4205C9.3535 13.4205 9.68638 13.1525 9.68638 12.7545V12.7458C9.68638 12.3133 9.35778 12.0885 8.86255 12.0885H8.08678V13.4202H8.84475L8.8451 13.4205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6685 11.9463C10.6685 11.8511 10.7471 11.7734 10.8393 11.7734H11.7333C12.6974 11.7734 13.3635 12.4265 13.3635 13.2783V13.2871C13.3635 14.1389 12.6974 14.8003 11.7333 14.8003H10.8393C10.7475 14.8003 10.6685 14.7224 10.6685 14.6275V11.9466V11.9463ZM11.7333 14.4846C12.5091 14.4846 13.0043 13.9657 13.0043 13.2955V13.2867C13.0043 12.6165 12.5091 12.0889 11.7333 12.0889H11.0145V14.4842H11.7333V14.4846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0952 11.9463C14.0952 11.8511 14.1739 11.7734 14.2661 11.7734H16.1637C16.2513 11.7734 16.3214 11.8426 16.3214 11.9291C16.3214 12.0155 16.2513 12.0889 16.1637 12.0889H14.4413V13.1697H15.9665C16.054 13.1697 16.1242 13.2389 16.1242 13.3254C16.1242 13.4118 16.054 13.481 15.9665 13.481H14.4413V14.6482C14.4413 14.7434 14.3626 14.8211 14.2661 14.8211C14.1696 14.8211 14.0952 14.7431 14.0952 14.6482V11.9459V11.9463Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_371_92714",
    x1: 9.18,
    y1: 20.1866,
    x2: 6.5984,
    y2: 11.5747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F36C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_92714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white",
    transform: "translate(4 2.375)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdfIcon.fd01a18191649512284bd6d3f1e4e0af.svg";